export const setValue = (state) => {
    console.log(state,"in action")
    return {
      type: "SET_VALUE",
      state: state
    };
  };